import { render } from "./hero.vue?vue&type=template&id=1a381146&scoped=true"
import script from "./hero.vue?vue&type=script&lang=js"
export * from "./hero.vue?vue&type=script&lang=js"

import "./hero.vue?vue&type=style&index=0&id=1a381146&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1a381146"

export default script